<div *ngIf="value" class="gt-green tf-badge">{{trueText}}
    <mat-icon>{{trueMatIcon}}</mat-icon></div>
<div *ngIf="value === false" class="gt-red tf-badge">{{falseText}}
    <mat-icon>{{falseMatIcon}}</mat-icon></div>